'use client';

import { useCallback, useEffect } from 'react';

interface KeyboardShortcutProps {
    key: string;
    ctrlKey?: boolean;
    shiftKey?: boolean;
    altKey?: boolean;
}

/**
 *
 * @param callback
 * @param shortcut_keys
 */
export const useKeyboardShortcut = (
    callback: VoidFunction,
    shortcut_keys: KeyboardShortcutProps
) => {
    const { key, altKey, ctrlKey, shiftKey } = shortcut_keys;
    const onHandleKeyboard = useCallback(
        (event: KeyboardEvent) => {
            const isKey = event.key === key.toLowerCase();
            const isCtrlKey = ctrlKey ? event.ctrlKey : true;
            const isShiftKey = shiftKey ? event.shiftKey : true;
            const isAltKey = altKey ? event.altKey : true;

            if (isKey && isCtrlKey && isShiftKey && isAltKey) {
                event.preventDefault();
                callback();
            }
        },
        [altKey, callback, ctrlKey, key, shiftKey]
    );

    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener('keydown', onHandleKeyboard);
        }
        return () => {
            if (typeof window !== 'undefined') {
                window.removeEventListener('keydown', onHandleKeyboard);
            }
        };
    }, [onHandleKeyboard]);
};
